export const COMPLAIN_ROUTING = [
    {
        path: '/complain',
        name: 'complain',
        meta: {
            auth: true,
            breadcrumb: [
                { name: 'Khiếu nại', pathName: 'complain', icon: 'fa fa-slack' },
            ]
        },
        component: () => import('./Complain.vue'),
        redirect: { name: 'complain-index' },
        children: [
            {
                path: '/khieu-nai.html',
                name: 'complain-index',
                component: () => import('./list/List.vue'),
            },
        ]
    }
];